import React, { useState } from 'react';
import { IntegratedSystemsDTO, IntegratedSystemType } from '../../api/useClientSettingsQuery';
import { UnlinkAndDeleteModal } from '../UnlinkAndDeleteModal/UnlinkAndDeleteModal';
import { Text } from '../../../CommonComponents/OPL/Text/Text';
import { Box } from '../../../CommonComponents/OPL/Box/Box';
import { IconButton } from '../../../CommonComponents/OPL/IconButton/IconButton';
import { Tooltip } from '../../../CommonComponents/OPL/Tooltip/Tooltip';
import { useCanUnlinkOrionConsumerQuery } from '../../api/useCanUnlinkOrionConsumerQuery';

interface Props {
  integratedSystems: IntegratedSystemsDTO[];
}

export const Integrated: React.FC<Props> = ({ integratedSystems }) => {
  const [isUnlinkModalOpen, setIsUnlinkModalOpen] = useState(false);

  const { data } = useCanUnlinkOrionConsumerQuery();

  if (!integratedSystems) {
    return null;
  }

  return (
    <>
      {isUnlinkModalOpen && <UnlinkAndDeleteModal onClose={() => setIsUnlinkModalOpen(false)} />}

      <Box
        mt="32"
        as="ul"
        css={`
          list-style: none;
          padding: 0;
        `}
      >
        {integratedSystems.map(({ Name: name, Id: id }) => (
          <Box mb="32" as="li" key={id}>
            <Text
              fontWeight={500}
              as="span"
              id={
                name === IntegratedSystemType.OrionConnect ? 'unlink-icon-button-label' : undefined
              }
            >
              Integrated from {name} with Id {id}
            </Text>

            {data && name === IntegratedSystemType.OrionConnect && (
              <Tooltip content="Unlink" placement="top">
                <IconButton
                  aria-labelledby="unlink-icon-button-label"
                  icon="far fa-link"
                  variant="subtleActive"
                  ml="4"
                  onClick={() => setIsUnlinkModalOpen(true)}
                />
              </Tooltip>
            )}
          </Box>
        ))}
      </Box>
    </>
  );
};
